export default "__VITE_ASSET__Cb6Qam8D__"